import { DEFAULT_ROUTES } from '@price-for-profit/drive-app-core';

export const ROUTES = {
    ...DEFAULT_ROUTES,
    analytics: '/analytics',
} as const;
